import { Text, TextColor, TextSize } from '@vizit/atoms';
import React from 'react';

function TrendUpIcon() {
  return (
    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" aria-hidden="true" className="text-success-500">
      <path
        d="M0.75 5.75L5.75 0.75M5.75 0.75H0.75M5.75 0.75V5.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TrendDownIcon() {
  return (
    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" aria-hidden="true" className="text-error-primary">
      <path
        d="M0.75 0.75L5.75 5.75M5.75 5.75V0.75M5.75 5.75H0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Props for the ProductListingRowChange component
 */
export interface ProductListingRowChangeProps {
  /**
   * The score change/delta between live score and user's score.
   * Positive values indicate improvement, negative values indicate decline.
   *
   * @optional
   * @type number | null
   */
  scoreChange?: number | null;
}

const ProductListingRowChange = React.memo<ProductListingRowChangeProps>(({ scoreChange }) => {
  if (scoreChange == null || scoreChange === 0) {
    return (
      <Text size={TextSize.Sm} color={TextColor.Tertiary} className="w-12 text-center">
        -
      </Text>
    );
  }

  const isPositive = scoreChange > 0;
  const absDiff = Math.abs(scoreChange);

  return (
    <output
      aria-label={`Score ${isPositive ? 'increased' : 'decreased'} by ${absDiff}`}
      className="flex items-center h-11 bg-primary gap-3 rounded-md border px-4 py-2 w-fit"
    >
      {isPositive ? <TrendUpIcon /> : <TrendDownIcon />}
      <span className="text-xs font-medium">{absDiff}</span>
    </output>
  );
});

ProductListingRowChange.displayName = 'ProductListingRowChange';

export { ProductListingRowChange };
